$(document).ready(function(){
    $(".product-video-thumb-icon").click(function () {
        // Play the video when the thumbnail is clicked
        var video = $(this).closest('.product-video').find("video")[0];
        video.play();
        $(this).closest('.product-video').addClass('show');
    });
    $(".product-video video").on('click', function () {
        // Pause the video when the video itself is clicked
        var video = $(this)[0];
        video.pause();
        $(this).closest('.product-video').find(".product-video-thumb").removeClass('show');
    });
    $(".product-video-stop").on('click', function () {
        // Find the video inside the same .product-video container and pause it
        var video = $(this).closest('.product-video').find("video")[0]; 
        video.pause();
        $(this).closest('.product-video').find(".product-video-thumb").addClass('show');
        $(this).closest('.product-video').removeClass('show');
    });

    // Function to initialize or destroy the sliders based on screen size
function handleSliders() {
    // First slider
    if (window.matchMedia("(max-width: 550px)").matches) {
      if (!$('.real-stories-blocks').hasClass('slick-initialized')) {
        // Initialize first slider if it's not already initialized
        $('.real-stories-blocks').slick({
          infinite: false,
          slidesToShow: 1,
          arrows: false,
          dots: true,
          slidesToScroll: 1
        });
      }
  
      if (!$('.shop-by-player-block').hasClass('slick-initialized')) {
        // Initialize second slider if it's not already initialized
        $('.shop-by-player-block').slick({
          infinite: false,
          slidesToShow: 2.2,
          arrows: true,
          dots: true,
          slidesToScroll: 1
        });
      }
    } else {
      if ($('.real-stories-blocks').hasClass('slick-initialized')) {
        // Destroy first slider if screen is wider than 550px
        $('.real-stories-blocks').slick('unslick');
      }
  
      if ($('.shop-by-player-block').hasClass('slick-initialized')) {
        // Destroy second slider if screen is wider than 550px
        $('.shop-by-player-block').slick('unslick');
      }
    }
  }
  
  // Call the function initially
  handleSliders();
  
  // Listen for window resize events
  $(window).resize(function() {
    handleSliders();
  });

  
});